const OPTIONAL_COMPONENT_NAMES = {
  Roadside: 'AARS',
  ConsumableItems: 'Consumables',
  TravelDisruption: 'Travel Disruption',
};

const AA_PRODUCTS = {
  Advantage: {
    item_id: 'AAMBI-ADV',
    item_name: 'Mechanical Breakdown Insurance | Advantage',
    item_brand: 'Mechanical Breakdown Insurance',
    item_category: 'Partner Insurance',
    item_category2: 'Mechanical Breakdown',
    item_category3: 'Advantage',
  },
  'Advantage Plus': {
    item_id: 'AAMBI-ADVPLUS',
    item_name: 'Mechanical Breakdown Insurance | Advantage Plus',
    item_brand: 'Mechanical Breakdown Insurance',
    item_category: 'Partner Insurance',
    item_category2: 'Mechanical Breakdown',
    item_category3: 'Advantage Plus',
  },
};

// type ProspectCompleteResponse = {
//   quote: {
//     policyNumber?: string;
//     id: string;
//     premium: string;
//     term: string;        // months as string, coerced to number on division
//     excess: string;
//     claimLimit: string;
//     cover: string;       // e.g. 'Advantage' | 'Advantage Plus'
//     optionalComponents?: string;  // semicolon-separated e.g. 'Roadside;ConsumableItems'
//   };
//   applicant?: { email?: string };
// };

export const pushAAPurchaseEvent = (res) => {
  const policyId = res.quote.policyNumber || res.quote.id;
  const guardKey = `purchase_fired_${policyId}`;

  if (sessionStorage.getItem(guardKey)) return;
  sessionStorage.setItem(guardKey, 'true');

  const premium = parseFloat(res.quote.premium);
  const years = res.quote.term / 12;
  const benefits = (res.quote.optionalComponents || '')
    .split(';')
    .filter(Boolean)
    .map((c) => OPTIONAL_COMPONENT_NAMES[c] || c)
    .join(' | ');
  const itemVariant = [
    `${years} ${years === 1 ? 'Year' : 'Years'}`,
    `Excess ${(res.quote.excess || '').replace('$', '')}`,
    res.quote.claimLimit,
    benefits,
  ]
    .filter(Boolean)
    .join(' | ');

  const product = AA_PRODUCTS[res.quote.cover];
  if (!product) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: 'purchase',
    ecommerce: {
      transaction_id: policyId,
      value: premium,
      currency: 'NZD',
      items: [
        { ...product, item_variant: itemVariant, price: premium, quantity: 1 },
      ],
    },
  });

  if (res.applicant?.email) {
    const email = res.applicant.email.toLowerCase().trim();
    crypto.subtle
      .digest('SHA-256', new TextEncoder().encode(email))
      .then((hashBuffer) => {
        const guid = Array.from(new Uint8Array(hashBuffer))
          .map((b) => b.toString(16).padStart(2, '0'))
          .join('');
        window.dataLayer.push({ event: 'guid_hashed', guid });
      });
  }
};
